import Subscription from '../domain/Subscription';
import { injectable } from 'tsyringe';
import AbstractRestfulHttpService from './AbstractRestfulHttpService';
import ApiService from './ApiService';

@injectable()
export default class SubscriptionService extends AbstractRestfulHttpService<Subscription> {
  public constructor(apiService: ApiService) {
    super(Subscription, apiService);
  }

  public getAllByOrganization(organizationId: string): Promise<Subscription[]> {
    return this.getMany({ organizationId });
  }
}
